import { useAsertoApiWithAnonymousAccess, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useInfoClient() {
  const { tenantServiceUrl } = useConfig()

  return useAsertoApiWithAnonymousAccess(v1Api(tenantServiceUrl))
}
